export const insertPageState = {
  showActionMenu: false,
  fileToAttachSelected: false,
  fileToAttachToReport: null,
  originalFileToAttachToReport: null,
  updatedTransmissionReportFile: null,
  transmissionReportFileEnableCache: true,
};
